import { useInfiniteQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { gameBoxRoomService } from '../../../../services/games/games-boxes-rooms'
import type {
  GameBoxRoom,
  GetList,
} from '../../../../services/games/games-boxes-rooms/types'

export const GAMES_BOXES_ROOMS_QUERY_KEY = 'getGamesBoxesRoomsHistory'

export const useGetGamesBoxesRoomsHistory = (params: GetList.Input) => {
  const { data, isFetchingNextPage, isLoading, refetch, fetchNextPage } =
    useInfiniteQuery({
      queryKey: [GAMES_BOXES_ROOMS_QUERY_KEY, { ...params }],
      initialPageParam: 0,
      queryFn: ({ pageParam: skip }) => {
        return gameBoxRoomService.getList({
          ...params,
          take: 20,
          skip,
        })
      },
      getNextPageParam: (lastPage, _allPages, lastPageParam) => {
        if (lastPage?.error) return null

        if (lastPage && !lastPage?.data?.length) return null

        return lastPageParam + 1
      },
    })

  const gamesBoxesRooms = useMemo(() => {
    const gamesBoxesRooms = data?.pages?.flatMap((page) => {
      return page?.data
    })

    return gamesBoxesRooms
  }, [data?.pages])

  return {
    gamesBoxesRooms: gamesBoxesRooms as GameBoxRoom[],
    isFetchingNextPage,
    isLoading,
    nextPage: fetchNextPage,
    refetch,
  }
}
